import Component from "@ember/component";

export default class ConnectorContainer extends Component {}
